import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { appSelectors } from '@store/selectors/app.selectors';
import { combineLatest, debounceTime, switchMap } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { masterSelectors } from '@store/selectors/master.selectors';
import { FloatingAlertsService } from '@shared/components/floating-alerts/data/floating-alerts.service';
import { AcRoutingService } from '@core/services/routing/ac-routing.service';
import { userSelectors } from '@store/selectors/user.selectors';

export const societyAccessGuard: CanActivateFn = (route) => {
  const store = inject(Store<StoreState>);
  const router = inject(Router);
  const floatingAlertService = inject(FloatingAlertsService);
  const data = route.data;
  let societyId: string | null = null;
  if ('url' in data) {
    societyId = route.paramMap.get(data.url);
  } else {
    societyId = route.paramMap.get('societyId') ?? route.queryParamMap.get('societyId');
  }
  const check$ = combineLatest([store.select(appSelectors.generalLoading), store.select(userSelectors.webIsReady)]).pipe(
    debounceTime(100),
    filter(([isLoading, webIsReady]) => !isLoading && webIsReady)
  );
  return check$.pipe(
    switchMap(() => store.select(masterSelectors.societies)),
    map((societies) => !!societies && !!societies.find((society) => society.codigo === societyId)),
    map((allowed) => {
      if (allowed) {
        return true;
      }
      floatingAlertService.error('ROUTES.SOCIETY_ACCESS_NOT_ALLOWED');
      return router.createUrlTree(AcRoutingService.HOME_ROUTE());
    })
  );
};
